import React from "react";
import Chat from '../components/chat/Chat'

import './Chats.css'

function Chats() {
  return (
    <div className="chats">
      <Chat 
        name='Tiwa'
        message='Hey! how are you 😊'
        timestamp='35 minutes ago'
        profilePic='https://thingstoknow.com.ng/wp-content/uploads/2020/01/Tiwa-Savage-Net-worth.png'
      />
      <Chat 
        name='Stephanie'
        message='Wasup yo'
        timestamp='5 minutes ago'
        profilePic='https://netstorage-legit.akamaized.net/images/7e14943fe6417123.jpg'
      />
      <Chat 
        name='Riri'
        message='How about a date tonight? 😉'
        timestamp='2 minutes ago'
        profilePic='https://dailypost.ng/wp-content/uploads/2019/06/13430CF4-6F37-449A-AD7B-A9285C375E8A.jpeg'
      />
      <Chat 
        name='Tatiana'
        message="Hey, I can't wait to meet you😍"
        timestamp='50 minutes ago'
        profilePic='https://www.currentschoolnews.com/wp-content/uploads/2020/03/poster-girl.png'
      />
    </div>
  );
}

export default Chats;
